import type { Case } from '../store/api/casesApi'

/**
 * Format case display with prefix: <Mã cuộc thi> - <Tên cuộc thi>
 */
export function formatCaseDisplay(caseItem: Case): string {
  if (caseItem.case_number) {
    return `${caseItem.case_number} - ${caseItem.title}`
  }
  return caseItem.title
}

/**
 * Tên nguyên đơn cho 1 packet flow `dual_claimant_packets`.
 *
 * Priority:
 *   1. `case.scenario_a_claimant_name` / `scenario_b_claimant_name` (field riêng — admin set)
 *   2. Fallback `case.plaintiff` (cho scenario_a) / `case.defendant` (cho scenario_b)
 *   3. Fallback hard "Nguyên đơn A" / "Nguyên đơn B"
 */
export function getClaimantName(
  caseItem: Pick<Case, 'plaintiff' | 'defendant' | 'scenario_a_claimant_name' | 'scenario_b_claimant_name'> | undefined | null,
  side: 'scenario_a' | 'scenario_b',
): string {
  if (!caseItem) return side === 'scenario_a' ? 'Nguyên đơn A' : 'Nguyên đơn B'
  if (side === 'scenario_a') {
    return caseItem.scenario_a_claimant_name?.trim() || caseItem.plaintiff?.trim() || 'Nguyên đơn A'
  }
  return caseItem.scenario_b_claimant_name?.trim() || caseItem.defendant?.trim() || 'Nguyên đơn B'
}
